
import { useCallback, useState } from 'react';
import Modal from 'react-modal';
import { PendingObject, PendingOperation } from '../models/PendingObject';
import { ValidationMessage } from '../models/ValidationMessage';
import { useSwitch } from './SwitchHook';

interface ValidationWarningModalProps {
    isOpen: boolean;
    onCancel: () => any;
    onContinue: (pendingObject: PendingObject) => any;
    errors: ValidationMessage[] | null | undefined;
    pendingObject?: PendingObject
}

export default function ValidationWarningModal(props: ValidationWarningModalProps) {

    const { onContinue, pendingObject } = props;

    const handleOnContinue = useCallback(() => {
        if (pendingObject) {
            onContinue(pendingObject);
        }
    }, [pendingObject, onContinue]);


    return <Modal
        isOpen={props.isOpen}
        onRequestClose={props.onCancel}
        contentLabel="Modal"
        className="modal-dialog modal-dialog-centered"
        overlayClassName="react-modal-overlay"
    >
        <div className="modal-content">
            <div className="modal-body">
                <p>{operationToString(props.pendingObject?.operation)}を続行してもよろしいですか？</p>
                <ul>
                    {
                        props.errors
                            ? props.errors.map((error) => <li key={error.message}>{error.message}</li>)
                            : null
                    }
                </ul>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary rounded-pill" onClick={props.onCancel}>
                    キャンセル
                </button>
                <button type="button" className="btn btn-primary rounded-pill" onClick={handleOnContinue}>
                    続行
                </button>
            </div>
        </div>
    </Modal>
}

function operationToString(value?: PendingOperation) {
    if (!value) {
        return "";
    }

    if (value === 'addNormalCard') {
        return "カードの追加";
    } else if (value === 'changeCardCount') {
        return "枚数の変更";
    } else if (value === 'markFavoriteCard') {
        return "「推し」の追加";
    }
    console.warn("Unknown pending operation: ", value);
    return "";
}

type ValidationModalHook = [
    boolean,
    ValidationMessage[] | null | undefined,
    PendingObject | undefined,
    {
        setErrors: (value: React.SetStateAction<ValidationMessage[] | null | undefined>) => void,
        setPendingObject: (value: React.SetStateAction<PendingObject | undefined>) => void,
        open: () => void,
        close: () => void
    }
];

export function useValidationModal(): ValidationModalHook {
    const [isOpen, modalOperation] = useSwitch(false);
    const [errors, setErrors] = useState<ValidationMessage[] | null | undefined>(null);
    const [pendingObject, setPendingObject] = useState<PendingObject | undefined>();

    const close = useCallback(() => {
        modalOperation.off();
    }, [modalOperation]);

    const open = useCallback(() => {
        modalOperation.on();
    }, [modalOperation]);

    return [
        isOpen,
        errors,
        pendingObject,
        {
            setErrors,
            setPendingObject,
            open,
            close
        }
    ]
}